<template>
  <div class="container mx-auto py-10 px-3">
    <div class="flex flex-wrap">
      <div class="w-full md:w-2/3">
        <div class="mb-5">
          <search-bar v-model="search" @input="makeSearch" />
        </div>
        <div class="flex flex-wrap">
          <div
            v-for="(product) in products.hits"
            :key="product.sku"
            class="px-2 w-1/2 md:w-1/3 lg:w-1/4 mb-2"
          >
            <basic-product-card
              :label="product.label"
              :path="product.path"
              :slug="product.path[product.path.length - 1]"
              :price="product.price"
              :crossed-price="product.crossed_price"
              :cover="product.cover"
              :background="product.background"
              :stock-status="product.stock_status"
            />
          </div>
        </div>
      </div>
      <div
        class="w-full md:w-1/3 px-2"
      >
        <nuxt-link
          v-for="category in categories.hits"
          :key="category.id"
          class="mb-2 block"
          :to="$helpers.makeUri(category.path, 'category')"
        >
          <nuxt-link
            class="mb-2 block"
            :to="$helpers.makeUri(category.path, 'category')"
          >
            <div
              class="w-full mb-3 flex justify-center items-center font-funny text-3xl"
              :style="{
                height: '100px',
                backgroundImage: `url(${category.cover ? category.cover + '?resize=true&width=400' : require('../assets/fixtures/categorie_guinguette.jpg')})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center top',
              }"
              :class="{
                'text-white': typeof category.dark_background === 'undefined' ? true : category.dark_background
              }"
            >
              {{ category.label }}
            </div>
          </nuxt-link>
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<script>
import algoliasearch from 'algoliasearch/lite'
import ProductSearchResult from '../components/header/search/ProductSearchResult'
import BasicProductCard from '../components/general/BasicProductCard'
import SearchBar from '../components/header/search/SearchBar'

const client = algoliasearch('GS18F5F1NL', '4667e1a6962d23cb13aab5af604ed12c')

const search = async (search) => {
  const response = await client.multipleQueries([
    {
      indexName: 'products',
      query: search,
      params: {
        hitsPerPage: 10
      }
    },
    {
      indexName: 'categories',
      query: search,
      params: {
        hitsPerPage: 10
      }
    }
  ])

  return {
    products: response.results[0],
    categories: response.results[1]
  }
}

export default {
  components: {
    ProductSearchResult,
    BasicProductCard,
    SearchBar
  },
  async asyncData ({ route, app }) {
    return {
      ...await search(route.query.search || ''),
      search: route.query.search || ''
    }
  },
  data () {
    return {
      searching: false,
      queued: false
    }
  },
  head () {
    return {
      title: 'Résultats de recherche pour: ' + this.$route.query.search
    }
  },
  watchQuery: ['search'],
  mounted () {
    this.$gtmEvents.onRegularPageView()
  },
  methods: {
    async makeSearch () {
      if (this.searching) {
        this.queued = true
        return
      }
      this.searching = true
      const response = await search(this.search)
      this.products = response.products
      this.categories = response.categories
      this.searching = false
      if (this.queued) {
        this.queued = false
        await this.makeSearch()
      }
    }
  }
}
</script>
